module.exports = __webpack_public_path__ + "img/qrcode2.59afc038.png";